export type PluginId = "menubar-widget" | "dashboard" | "contextual-capture";

export type Plugin = {
  id: PluginId;
  name: string;
  asset: {
    small: string;
    large: string;
  };
};

const PLUGIN_ASSET_ID = "2XzKUaZnzENkFOmCZYGlef";

export const Plugins: Plugin[] = [
  {
    id: "dashboard",
    name: "Dashboard",
    asset: {
      small: new URL("../assets/settings/dashboard.png", import.meta.url).href,
      large: PLUGIN_ASSET_ID,
    },
  },
  {
    id: "menubar-widget",
    name: "Menu Bar Widget",
    asset: {
      small: new URL("../assets/settings/menubar.png", import.meta.url).href,
      large: PLUGIN_ASSET_ID,
    },
  },
  {
    id: "contextual-capture",
    name: "Contextual Capture",
    asset: {
      small: new URL("../assets/settings/capture.png", import.meta.url).href,
      large: PLUGIN_ASSET_ID,
    },
  },
];

const PluginMap = new Map(Plugins.map((p) => [p.id, p]));

export function getPlugin(id: PluginId): Plugin | undefined {
  return PluginMap.get(id);
}
